import {useMutation, useQueryClient} from 'react-query';
import {toast} from 'react-toastify';
import {convertErrorsToPersian} from './bankAccountErrorMapper';
import {
  IPostBankAccountInfoPayload,
  postBankAccountInfo,
} from './postBankAccountInfo';
import {extractApiErrors} from '../../../../../global/helpers/extractApiErrors';

const usePostBankAccountInfo = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (payload: IPostBankAccountInfoPayload) =>
      postBankAccountInfo(payload),

    onSuccess: () => {
      queryClient.invalidateQueries(['get-bank-account-info']);
    },

    onError: error => {
      const errors = extractApiErrors(error);
      const persianErrors = convertErrorsToPersian(errors);

      persianErrors.forEach(message => toast.error(message));
    },
  });
};

export default usePostBankAccountInfo;
